import { css } from '@emotion/react';

export default $ => css`
  ${Array.from({ length: 6 }, (_, i) => i + 1).map(i => `
    .from-col-${i} {
      grid-column-start: ${i} !important;
    }
    
    .to-col-${i + 1} {
      grid-column-end: ${i + 1} !important;
    }
    
    .from-row-${i} {
      grid-row-start: ${i} !important;
    }
    
    .to-row-${i + 1} {
      grid-row-end: ${i + 1} !important;
    }

    ${Array.from({ length: 6 }, (_, j) => j + 1).map(j => `
      .from-col-${i}-size-${j} {
        grid-column-start: ${i} !important;
        grid-column-end: ${i + j} !important;
      }

      .from-row-${i}-size-${j} {
        grid-row-start: ${i} !important;
        grid-row-end: ${i + j} !important;
      }
    `).join('')}
  `).join('')}

  .pad-right {
    padding-right: 1rem;
  }

  .items-centered {
    justify-items: center;
  }

  .spaced {
    margin: 1rem 0;
  }

  .bordered {
    border: 1px solid ${$.gray100};
    border-radius: ${$.borderRadius};
    padding: 1rem;
  }

  .form-group.bordered {
    border: 1px solid ${$.gray100};
  }

  .flex-row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
`;
